export enum PromotionStatus {
    PENDING_ACTIVE = 0,
    ACTIVE = 1,
    WON = 2,
    PENDING_DELETED = 3,
    DELETED = 4,
    ENDED = 5,
}
